import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { Divider, Slider, Switch, Typography } from "@mui/material"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { languageOptions } from "../../../utils/LanguageList"

export default function PrerecordedAudioSnippet() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [partners, setSPartners] = useState([])
    const [voices, setVoices] = useState([])

    const { showSnackbar } = useSnackbar();


    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Data state
    const [snippetData, setSnippetData] = useState<any>((type === 'edit' || type === 'copy') ? [] :
        {
            "conversationtemplate": null,
            "voice": null,
            'language': 'en',
            "pitch": '',
            "tempo": '1',
            "normalize1": '',
            "compress": '',
            "denoise": '',
            "trim": '',
            "normalize2": '',
            audiofiles: [{ name: '', audiofile: '' }],

        }

    )

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Prerecorded Audio Snippet` : type === "copy" ? `Copy Prerecorded Audio Snippet` : 'Add Prerecorded Audio Snippet'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get prerecordedspeech
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/prerecordedspeech/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSnippetData(response.data[0])
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create prerecordedspeech
    async function postData(data: any = {}) {
        try {
            console.log(snippetData.audiofiles);

            const response = await axios.post(`https://cardgarantsales.com/restapi/prerecordedspeech`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit prerecordedspeech
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/prerecordedspeech/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Copy prerecordedspeech
    async function copyData(data: any = {}) {
        try {
            console.log(snippetData.audiofiles);

            const response = await axios.post(`https://cardgarantsales.com/restapi/prerecordedspeech/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data.filter((el: any) => el.showsetuptopartner == '1'));
            setConversationtemplates(accesslevel != 5 ? response.data.filter((el: any) => el.showsetuptopartner == '1') : response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get prerecordedvoices for Select field
    async function getVoices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/prerecordedvoices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setVoices(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get prerecorded speech data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        (type === 'edit' || type === 'copy') && fetchData()
        getConversationtemplates()
        getPartners()
        getVoices()
        console.log(snippetData);

    }, [type])

    function convertFileToBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                resolve(event.target.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    const [fileNames, setFileNames] = useState<string[]>([]);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            const newFiles = await Promise.all(
                Array.from(files).map(async (file) => ({
                    name: file.name.replace('.mp3', ''),
                    audiofile: await convertFileToBase64(file),
                }))
            );
            setFileNames(newFiles.map(({ name }) => name));
            type !== 'edit' ? setSnippetData({ ...snippetData, audiofiles: newFiles }) : setSnippetData({ ...snippetData, audiofile: newFiles[0].audiofile })
        } else {
            setFileNames([]);
            type !== 'edit' ? setSnippetData({ ...snippetData, audiofiles: [] }) : setSnippetData({ ...snippetData, audiofile: '' })
        }
    };




    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 400, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select key={snippetData.conversationtemplate} sx={{ width: 400 }} labelId="simple-select-label" onChange={(e) => setSnippetData({ ...snippetData, conversationtemplate: e.target.value })} value={snippetData.conversationtemplate} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            {
                                conversationtemplates.map((el: any) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Voice'} /></InputLabel>
                        <Select key={snippetData.voice} sx={{ width: 400 }} labelId="simple-select-label" onChange={(e) => setSnippetData({ ...snippetData, voice: e.target.value })} value={snippetData.voice} variant="outlined" size="small" label={<TranslatedText text={'Voice'} />} >
                            {
                                voices.map((el: any) => (
                                    <MenuItem key={el.id} value={el.voicecode}>{el.voicename}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <FormControl >
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Language"} /></InputLabel>
                        <Select key={snippetData.language} value={snippetData.language} sx={{ width: 400 }} onChange={(e) => setSnippetData({ ...snippetData, language: e.target.value })}  labelId="simple-select-label" variant="outlined" size="small" label={<TranslatedText text={"Language"} />} >
                            {languageOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {(type == 'edit' || type == 'copy') && <> <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} value={snippetData.code || ''}
                        label={<TranslatedText text={'Code'} />}
                        onChange={(e) => setSnippetData({ ...snippetData, code: e.target.value !== '' ? e.target.value : null })}
                        multiline
                        rows={1}
                        fullWidth
                        variant="outlined" />
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} value={snippetData.description || ''}
                            label={<TranslatedText text={"Audio fragment description"} />}
                            onChange={(e) => setSnippetData({ ...snippetData, description: e.target.value !== '' ? e.target.value : null })}
                            multiline
                            rows={1}
                            fullWidth
                            variant="outlined" />
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} value={snippetData.transcript || ''}
                            label={<TranslatedText text={"Transcript"} />}
                            onChange={(e) => setSnippetData({ ...snippetData, transcript: e.target.value !== '' ? e.target.value : null })}
                            multiline
                            rows={1}
                            fullWidth
                            variant="outlined" /></>}
                    <Button disabled={type == 'copy'} sx={{ width: '100%' }} variant="outlined" component="label">
                        {type !== 'copy' ? "Upload files (mp3)" : 'File <<copied>>'}
                        <input
                            type="file"
                            accept=".mp3"
                            multiple={type !== 'edit'}
                            hidden
                            onChange={handleFileChange}
                            disabled={type == 'copy'}
                        />
                    </Button>
                    {fileNames.length > 0 && (
                        <Box sx={{ width: '100%' }}>
                            <Typography gutterBottom>
                                {fileNames.length === 1
                                    ? `Selected file: ${fileNames[0]}.mp3`
                                    : `Selected files: ${fileNames.length}`}
                            </Typography>
                            <Divider />
                        </Box>

                    )}
                    {/* <TextField onChange={(e) => setSnippetData({ ...snippetData, pitch: e.target.value !== '' ? e.target.value : null })} value={snippetData.pitch || ''} variant="outlined" size="small" label='Change tone' /> */}
                    <Typography>
                        <TranslatedText text={'Change tone'} />
                    </Typography>
                    <Slider
                        onChange={(e: any) => setSnippetData({ ...snippetData, pitch: (e.target.value).toString() })}
                        disabled={(type === 'edit' && fileNames.length === 0)}
                        value={snippetData.pitch}
                        defaultValue={0}
                        valueLabelDisplay="auto"
                        step={1}
                        marks
                        track={false}
                        min={-500}
                        max={500}
                    />
                    <Typography>
                        <TranslatedText text={'Change speed'} />
                    </Typography>
                    <Slider
                        onChange={(e: any) => setSnippetData({ ...snippetData, tempo: (e.target.value).toString() })}
                        disabled={(type === 'edit' && fileNames.length === 0)}
                        value={snippetData.tempo}
                        defaultValue={1}
                        valueLabelDisplay="auto"
                        step={0.01}
                        marks
                        track={false}
                        min={0.1}
                        max={2}
                    />
                    {type !== 'copy' && <><Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <Typography><TranslatedText text={'Normalize'} /></Typography>
                        <Switch disabled={(type === 'edit' && fileNames.length === 0)} onChange={(e) => setSnippetData({ ...snippetData, normalize1: snippetData.normalize1 === '' ? '1' : '' })} checked={Boolean(+snippetData.normalize1)} />
                    </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Typography><TranslatedText text={'Compressor'} /></Typography>
                            <Switch disabled={(type === 'edit' && fileNames.length === 0)} onChange={(e) => setSnippetData({ ...snippetData, compress: snippetData.compress === '' ? '1' : '' })} checked={Boolean(+snippetData.compress)} />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Typography><TranslatedText text={'Remove noise'} /></Typography>
                            <Switch disabled={(type === 'edit' && fileNames.length === 0)} onChange={(e) => setSnippetData({ ...snippetData, denoise: snippetData.denoise === '' ? '1' : '' })} checked={Boolean(+snippetData.denoise)} />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Typography><TranslatedText text={'Remove silence'} /> (<TranslatedText text={'before and after'} />)</Typography>
                            <Switch disabled={(type === 'edit' && fileNames.length === 0)} onChange={(e) => setSnippetData({ ...snippetData, trim: snippetData.trim === '' ? '1' : '' })} checked={Boolean(+snippetData.trim)} />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Typography><TranslatedText text={'Normalize 2nd time'} /></Typography>
                            <Switch disabled={(type === 'edit' && fileNames.length === 0)} onChange={(e) => setSnippetData({ ...snippetData, normalize2: snippetData.normalize2 === '' ? '1' : '' })} checked={Boolean(+snippetData.normalize2)} />
                        </Box></>}
                </Box>
                <Button onClick={() => type === "edit" ? putData(snippetData) : type === 'copy' ? copyData(snippetData) : postData(snippetData)} variant="contained" sx={{ width: "100%" }}>{type === 'copy' ? <TranslatedText text={"Copy"} /> : <TranslatedText text={"Save"} />}</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/prerecordedaudiosnippets' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={"Saving error"} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={"Successfully saved"} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}